import MultiValueInput from './MultiValueInput';

export default MultiValueInput;
